export default __webpack_public_path__ + "static/media/bakti-suci.8525e119.png";